import { useRef } from "react";
import {
    Grid,
    Slide,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SideBarHeader from "./SideBarHeader";
import SideBarContent from "./SideBarContent";
import { getChats } from "../../../services/Chat";
import { useInfiniteQuery } from "react-query";

const SidebarLayout = ({
    isFullScreen,
    handleNewChat,
    isMenuOpen,
    setIsMenuOpen,
}) => {
    const ref = useRef(null);
    const Root = styled("div")(({ theme }) => ({
        width: "300px",
        backgroundColor: theme.palette.background.paper,
    }));

    // Fetch all chats
    const {
        data,
        isLoading,
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
    } = useInfiniteQuery(
        "getChats",
        getChats,
        {
            getNextPageParam: (lastPage) => lastPage?.lastEvaluatedKey ?? undefined,
            refetchOnWindowFocus: false,
        }
    );

    return (
        <Grid
            sx={{
                flexDirection: "column",
                height: "fit-content",
            }}
            ref={ref}
        >
            <Slide
                direction="right"
                in={isMenuOpen}
                mountOnEnter
                unmountOnExit
                container={ref.current}
            >
                <Root>
                    <SideBarHeader
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                        handleNewChat={handleNewChat}
                    />
                    <SideBarContent
                        isFullScreen={isFullScreen}
                        setIsMenuOpen={setIsMenuOpen}
                        isLoading={isLoading}
                        data={data}
                        fetchNextPage={fetchNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        hasNextPage={hasNextPage}
                    />
                </Root>
            </Slide>
        </Grid>
    );
};

export default SidebarLayout;